import { inject, Injectable } from '@angular/core';

import { ROUTES } from '@core/constants';
import { IResponseHttp, WorkSummaryStatus } from '@core/models';
import { ApiService } from '@core/services';

@Injectable({
  providedIn: 'root',
})
export class WorkSummaryService {
  private readonly api = inject(ApiService);

  async getStatus(orderId: string): Promise<WorkSummaryStatus> {
    const result = await this.api.get<IResponseHttp>(ROUTES.ADMIN_WORK_SUMMARY(orderId));
    return result.payload;
  }

  /** Pone en cola el resumen de una orden cerrada que no lo tiene, o reintenta uno fallido. */
  async request(orderId: string): Promise<WorkSummaryStatus> {
    const result = await this.api.post<IResponseHttp>(
      ROUTES.ADMIN_WORK_SUMMARY(orderId),
      {},
    );
    return result.payload;
  }
}
